<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="users" :search="search">
          <template #top>
            <v-toolbar flat>
              <v-toolbar-title>Users</v-toolbar-title>
              <v-divider class="mx-4" inset vertical />
              <v-spacer />
              <v-dialog v-model="dialog" max-width="800px">
                <template #activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    New User
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            v-model="userForm.email"
                            :error-messages="userForm.errors.email"
                            label="E-Mail"
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="userForm.password"
                            :error-messages="userForm.errors.password"
                            label="Passwort"
                          />
                        </v-col>
                        <v-col cols="2">
                          <v-select
                            v-model="userForm.contact_person.form_of_address"
                            :items="[{ text: 'Herr', value: 'Mr.' },{ text: 'Frau', abbr: 'Mrs.' }]"
                            label="Anrede"
                          />
                        </v-col>
                        <v-col cols="5">
                          <v-text-field
                            v-model="userForm.contact_person.first_name"
                            :error-messages="
                              userForm.errors.contact_person
                                ? userForm.errors.contact_person.first_name
                                : ''
                            "
                            label="Vorname"
                          />
                        </v-col>
                        <v-col cols="5">
                          <v-text-field
                            v-model="userForm.contact_person.last_name"
                            :error-messages="
                              userForm.errors.contact_person
                                ? userForm.errors.contact_person.last_name
                                : ''
                            "
                            label="Nachname"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field v-model="userForm.phone_number_1" label="Telefonnummer" />
                        </v-col>
                        <v-col>
                          <v-text-field v-model="userForm.phone_number_2" label="Telefonnummer" />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field v-model="userForm.address" label="Adresse" />
                        </v-col>
                        <v-col>
                          <v-text-field v-model="userForm.postal" label="Postleitzahl" />
                        </v-col>
                        <v-col>
                          <v-text-field v-model="userForm.city" label="Stadt" />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" text @click="close">
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      :loading="userForm.processing"
                      @click="save"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template #[`item.created_at`]="{ item }">
            {{ getDateString(item.created_at) }}
          </template>
          <template #[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import { formattedDateTimeString } from '@/plugins/formatDate.js'

export default {
   name: 'UserIndex',
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'User',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      users: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         dialog: false,
         headers: [
            { text: 'Name', value: 'name' },
            { text: 'Team', value: 'teamName' },
            { text: 'Rolle', value: 'teamRole' },
            { text: 'E-Mail', value: 'email' },
            { text: 'Erstellungsdatum', value: 'created_at' },
            { text: '', value: 'actions', sortable: false },
         ],
         editedIndex: -1,
         search: null,
         userForm: this.$inertia.form({
            name: null,
            email: null,
            password: null,
            phone_number_1: null,
            phone_number_2: null,
            address: null,
            postal: null,
            city: null,
            contact_person: {
               form_of_address: 'Mr.',
               first_name: null,
               last_name: null
            },
         }),
      }
   },
   computed: {
      formTitle () {
         return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      }
   },
   watch: {
      dialog (val) {
         val || this.close()
      },
      'userForm.recentlySuccessful' (val) {
         if (val) {
            this.close()
            this.reset()
         }
      },
      'userForm.contact_person.first_name' (val) {
         if (val) {
            this.userForm.name = this.userForm.contact_person.first_name + ' ' + this.userForm.contact_person.last_name
         }
      },
      'userForm.contact_person.last_name' (val) {
         if (val) {
            this.userForm.name = this.userForm.contact_person.first_name + ' ' + this.userForm.contact_person.last_name
         }
      },
   },

   methods: {
      getDateString (dateVal) {
         return formattedDateTimeString(dateVal)
      },
      editItem (item) {
         this.editedIndex = item.id

         this.userForm.name = item.name
         this.userForm.email = item.email
         this.userForm.password = null
         this.userForm.contact_person.form_of_address = item.contact_person.form_of_address
         this.userForm.contact_person.first_name = item.contact_person.first_name
         this.userForm.contact_person.last_name = item.contact_person.last_name

         this.userForm.phone_number_1 = item.phone_number_1
         this.userForm.phone_number_2 = item.phone_number_2
         this.userForm.address = item.address
         this.userForm.postal = item.postal
         this.userForm.city = item.city

         this.dialog = true
      },
      close () {
         this.dialog = false
         this.$nextTick(() => {
            this.reset()
            this.editedIndex = -1
         })
      },
      reset () {
         this.userForm.name = null
         this.userForm.email = null
         this.userForm.password = null
         this.userForm.contact_person.form_of_address = 'Mr.'
         this.userForm.contact_person.first_name = null
         this.userForm.contact_person.last_name = null

         this.userForm.phone_number_1 = null
         this.userForm.phone_number_2 = null
         this.userForm.address = null
         this.userForm.postal = null
         this.userForm.city = null

         this.userForm.clearErrors()
      },

      save () {
         if (this.editedIndex > -1) {
            this.userForm.patch(this.route('admin.user.update', this.editedIndex))
         } else {
            this.userForm.post(this.route('admin.user.store'))
         }
      },
   },
}
</script>

<style></style>
